import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const redirectUrl = router.createUrlTree(['/login']);

  return !!localStorage.getItem('accessToken') || redirectUrl;
};
